import { paciente } from '../../api/paciente';
import { usePedido } from '../../api/usePedido';
import { irA } from '../../router';
import type { ScreenProps } from '../../routes/types';
import { Boton, Cargando, FalloDeCarga, Icono, InsigniaEstadoTurno, Tarjeta } from '../../ui';
import { fechaLarga, pesos } from '../../ui/format';

export function Confirmacion({ params }: ScreenProps) {
  const id = Number(params['id']);
  const pedido = usePedido(() => paciente.turno(id), [id]);
  if (pedido.estado === 'cargando') return <Cargando />;
  const turno = pedido.datos;
  if (!turno) return <FalloDeCarga mensaje={pedido.error ?? 'No encontramos el turno'} alReintentar={pedido.recargar} />;

  const confirmado = turno.estado === 'confirmado';
  return (
    <div className="confirmacion">
      <Tarjeta>
        <div className={confirmado ? 'confirmacion__icono' : 'confirmacion__icono confirmacion__icono--pendiente'}>
          <Icono nombre={confirmado ? 'check-circle' : 'clock'} tamano={36} />
        </div>
        <h1>{confirmado ? '¡Listo, tu turno está confirmado!' : 'Recibimos tu reserva'}</h1>
        <p>{confirmado
          ? 'Te mandamos la confirmación por WhatsApp y un recordatorio el día anterior.'
          : 'El pago de la seña está en revisión. Te avisamos apenas se acredite.'}</p>
        <dl className="reserva__resumen">
          <div><dt>Profesional</dt><dd>{turno.profesional.nombre} {turno.profesional.apellido}</dd></div>
          <div><dt>Servicio</dt><dd>{turno.servicio.nombre}</dd></div>
          <div><dt>Cuándo</dt><dd>{fechaLarga(turno.fecha)} a las {turno.hora_inicio}</dd></div>
          <div><dt>Dónde</dt><dd>{turno.modalidad === 'videoconsulta' ? 'Por videoconsulta' : `${turno.profesional.direccion}, ${turno.profesional.barrio}`}</dd></div>
          {turno.pago && <div><dt>Seña</dt><dd>{pesos(turno.pago.monto)} · {turno.pago.estado === 'aprobado' ? 'acreditada' : 'en revisión'}</dd></div>}
          <div><dt>Estado</dt><dd><InsigniaEstadoTurno estado={turno.estado} /></dd></div>
          <div><dt>Código</dt><dd className="codigo">#{turno.codigo}</dd></div>
        </dl>
        <div className="reserva__acciones">
          <Boton variante="secundario" onClick={() => irA('/buscar')}>Buscar otro profesional</Boton>
          <Boton onClick={() => irA('/mis-turnos')}>Ver mis turnos</Boton>
        </div>
      </Tarjeta>
    </div>
  );
}
